import React, { Component,PureComponent, Fragment } from 'react';
import { Modal} from 'reactstrap';
import { connect } from 'react-redux';
import {getFormValues} from 'redux-form';
import {hideLoading, showLoading} from "../../../../store/actions/ui";
import api from "../../../../utils/api";
import PropTypes from 'prop-types';
import _ from "lodash";
class EqualDiscount extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isShowModal: false,
            list: [],
            selected: null,
            disabled: true,
        };
    }





    /**
     * close modal
     */
    onCloseModal = () => {
        this.props.onSelect(this.state.selected, "equal_discount");
    }


    /**
     * detect open modal
     */
    onOpened = () => {
        let plans_line_not_null = _.reject(this.props.plans, {plan: null});// số plan đã chọn
        this.setState({
            list: plans_line_not_null,
            selected: this.props.selected
        })
    }

    onSelect = (e, value) => {
        if(value==true){
            this.setState({
                selected: this.state.list
            }, () => {
                this.toggleModal(e)
            })
        }
        else{
            this.setState({
                selected: value
            }, () => {
                this.toggleModal(e)
            })
        }

    }

    toggleModal = (e) => {
        e.preventDefault();
        this.setState({
            isShowModal: !this.state.isShowModal
        })
    }


    componentDidUpdate(prevProps){
        if(prevProps.selected && prevProps.selected !== this.props.selected){
            this.setState({
                selected: this.props.selected
            })
        }
 

    }
    render() {
        //let selected = this.props.selected;

        return(
            <Fragment>
                <div className="form-group">
                    <label className="text-name text-wrap text-bold">동일할인
                    </label>
                    <button className="btn btn-input-form h-32 mb-0" type="button"
                            onClick={(e) => this.toggleModal(e)}
                            disabled={_.reject(this.props.plans, {plan: null}).length > 0  && (!this.props.kt_premium_discount) ? (!this.props.discount_indicated ? false : true)  : true}
                    >
                        {/* disabled kt_premium_discount 가 활성화 되면 해당 항목을 비활성화 */}
                        { this.props.selected ? "적용"  : "미적용"}
                        {/* 유무선결합 적용 선택 시 우측의 적용,미적용 상태인지 알리는 것 */}
                    </button>
                    <Modal isOpen={this.state.isShowModal}
                           className="modal-dialog modal-dialog-centered modal-additional"
                           contentClassName="pl-4 pr-4"
                           toggle = {(e) => this.toggleModal(e)}
                           onOpened = {this.onOpened}
                           onClosed = {this.onCloseModal}
                           // backdrop={"static"}
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">동일할인</h5>
                            <button type="button" className="close close-modal"
                                    onClick={(e) => this.toggleModal(e)}
                            >
                               <img src={process.env.REACT_APP_HOSTNAME + "/images/icon-close.svg"} alt="" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <ul className="list-additional ">
                                <li className={ !this.props.selected ? "active" : "" }
                                    onClick={(e) => this.onSelect(e, false)}
                                >
                                    미적용
                                </li>
                                <li className={this.props.selected ? "active" : "" }
                                    onClick={(e) => this.onSelect(e, true)}
                                >
                                    적용
                                </li>

                            </ul>
                        </div>
                    </Modal>
                </div>
            </Fragment>
        );
    }
}

EqualDiscount.propTypes = {
    toggleModal: PropTypes.func,
    isShowModal: PropTypes.bool,
    onSelect: PropTypes.func,
    selected: PropTypes.object,
};

const mapStateToProps = state => {
    return {
    };
};
const mapDispatchToProps = dispatch => {
    return {
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading()),
    };
};

export default connect(mapStateToProps ,mapDispatchToProps )(EqualDiscount);